import { installRefreshTagRuntime } from "./refresh_tags_impl";

installRefreshTagRuntime();
